import {auth} from '@/lib/firebaseAuth';

/**
 * Fetches the resume file for the authenticated user.
 * @returns {Promise<Blob>} The resume file as a Blob.
 */
export const fetchResumeFile = async () => {
    const firebaseUser = auth.currentUser;
    if (!firebaseUser) {
        throw new Error('Authentication required. Please sign in.');
    }

    const idToken = await firebaseUser.getIdToken();

    const response = await fetch(`${import.meta.env.VITE_API_URL}/resume`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${idToken}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to fetch resume.');
    }

    return await response.blob();
};